import { env } from '../common/util/env';
import { OfferType } from './types';

export const OFFERS_ENDPOINT = '/api/1/offers';

export const OFFERS_PREVIEW_ENDPOINT = '/api/1/offers/preview';

const { OFFERS_HOST } = env;

export const makeOffersUrl = (preview: boolean, slugs: string[], type: OfferType) => {
  const endpoint = preview ? OFFERS_PREVIEW_ENDPOINT : OFFERS_ENDPOINT;
  const slugParam = slugs.length ? '&slug=' + slugs.join(',') : '';
  const url = `${OFFERS_HOST}${endpoint}?content_type=${type}${slugParam}`;
  return url;
};
